// FILE: stratify_website/src/pages/AboutPage.jsx
import React from "react";
import { SITE } from "../config/site";
import { Meta } from "../layout/EducationMeta";
import GlassCard from "../components/ui/GlassCard";
import Link from "../components/Link";

export default function AboutPage() {
  const PAGE =
    "mx-auto w-full max-w-[110rem] px-4 md:px-6 lg:px-8 xl:px-10 2xl:px-12";

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE.name,
      url: SITE.url,
      logo: `${SITE.url}/images/StratifyLogo.png`,
      description: SITE.description,
    },
  ];

  return (
    <div className={`${PAGE} py-12`}>
      <Meta
        title="About — Stratify Backtesting"
        description="Meet the founders behind Stratify Backtesting and learn why we’re building a strategy wallet for backtesting and signal monitoring."
        canonical={`${SITE.url}/about`}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />

      <div className="max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-ink">
          About Stratify
        </h1>
        <p className="mt-4 text-muted leading-relaxed">
          Stratify is a strategy wallet for building, backtesting, and monitoring trading
          strategies — designed to reduce noise and keep you consistent.
        </p>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-2 max-w-4xl">
        <GlassCard className="p-6">
          <div className="text-sm text-muted">Co-Founder</div>
          <div className="mt-2 text-xl font-semibold text-ink">Justen Chartrand</div>
          <p className="mt-3 text-sm text-muted leading-relaxed">
            Building a clean, mobile-first workflow for strategy tracking and backtesting.
          </p>
          <div className="mt-5">
            <Link
              to="/about/justen-chartrand"
              className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-xs font-semibold text-ink/80
                         bg-white ring-1 ring-ink/10 hover:bg-bg1 hover:text-ink transition"
            >
              View profile →
            </Link>
          </div>
        </GlassCard>

        <GlassCard className="p-6">
          <div className="text-sm text-muted">Co-Founder</div>
          <div className="mt-2 text-xl font-semibold text-ink">Marco Schapira</div>
          <p className="mt-3 text-sm text-muted leading-relaxed">
            Focused on strategy design, product direction, and building the next layer of
            trading workflow.
          </p>
          <div className="mt-5">
            <Link
              to="/about/marco-schapira"
              className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-xs font-semibold text-ink/80
                         bg-white ring-1 ring-ink/10 hover:bg-bg1 hover:text-ink transition"
            >
              View profile →
            </Link>
          </div>
        </GlassCard>
      </div>
    </div>
  );
}
